// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"d6bb0ddc","234":"ab4de245","617":"4de7f92c","664":"856aa565","697":"9515159d","974":"764a3f30"}[chunkId] + ".chunk.js";
};